import { Injectable } from '@angular/core';
import { Router } from "@angular/router";
import { HttpClient } from '@angular/common/http';


import { AbstractEndpoint } from './abstract-endpoint.service';
import { Abstract } from '../models/abstract/abstract.model';
import { AbstractDetail } from '../models/abstract/abstract-detail.model';
import { AbstractSearchResult } from '../models/abstract/abstract-search-result.model';
import { AbstractSearchKeys } from '../models/abstract/abstract-search.model';
import { AbstractByStatus } from '../models/abstract/abstract-by-status.model';
import { AbstractSearchMetadata } from '../models/abstract/abstract-search-metadata.model';
import { Evaluation } from '../models/evaluation/evaluation.model';

import { ActionAbstracts } from '../models/abstract/action-abstracts.model';
import { AbstractViewCheck } from '../models/abstract/abstract-view-check.model';
import { Roles } from '../models/enums';
import { AutoSampleResult } from '../models/abstract/auto-sample-result.model';



@Injectable({ providedIn: 'root'})
export class AbstractService {

  constructor(private router: Router, private http: HttpClient, private abstractEndpoint: AbstractEndpoint) {

  }

  canUserAttemptCodeAbstract(abstractId?: number, protocolId?: number, activeRole?: Roles, activeTeam?: number) {
    return this.abstractEndpoint.canUserAttemptCodeAbstract<AbstractViewCheck>(abstractId, protocolId, activeRole, activeTeam)
  }

  getOverrideAbstract(abstractId?: number, protocolId?: number, activeRole?: Roles) {
    return this.abstractEndpoint.getOverrideAbstractEndpoint<boolean>(abstractId, protocolId, activeRole);
  }

  getAbstractById(abstractId?: number) {
    return this.abstractEndpoint.getAbstractByIdEndpoint<Abstract>(abstractId);
  }

  getRoleFilteredAbstractById(abstractId?: number, activeRole?: Roles) {
    return this.abstractEndpoint.getRoleFilteredAbstractByIdEndpoint<Abstract>(abstractId, activeRole);
  }

  getNextAbstract(activeRole: Roles, activeTeam: number, activeProject: number, mode: number) {
    return this.abstractEndpoint.getNextAbstract<Abstract>(activeRole, activeTeam, activeProject, mode);
  }

  getAbstractsByParams(searchKeys: AbstractSearchKeys) {
    return this.abstractEndpoint.getAbstractsByParamsEndpoint<AbstractSearchResult>(searchKeys);
  }

  getAbstractSearchMetadata(activeRole: Roles, protocolId: number, activeProject: number, filterByProtocol: boolean) {
    return this.abstractEndpoint.getAbstractSearchMetadataEndpoint<AbstractSearchMetadata>(activeRole, protocolId, activeProject, filterByProtocol);
  }

  getAbstractSpreadsheetTemplate() {
    return this.abstractEndpoint.getAbstractSpreadsheetTemplateEndpoint<ArrayBuffer>();
  }

  importAbstract(file: File, odpProjectWorkflowId: number, protocolId: number) {
    return this.abstractEndpoint.importAbstractEndpoint(file, odpProjectWorkflowId, protocolId);
  }

  addAbstract(abstract: Abstract) {
    return this.abstractEndpoint.addAbstractEndpoint<Abstract>(abstract);
  }

  updateAbstract(abstract: Abstract) {
    return this.abstractEndpoint.updateAbstractEndpoint<Abstract>(abstract);
  }

  updateAbstractStatus(abstractList: Abstract[]) {
    return this.abstractEndpoint.updateAbstractStatusEndpoint<Abstract[]>(abstractList);
  }


  getFullAbstractForEvaluation(abstractId: number, protocolId: number, activeRole: Roles, activeTeam: number) {
    return this.abstractEndpoint.getFullAbstractForEvaluationEndpoint<Evaluation>(abstractId, protocolId, activeRole, activeTeam);
  }

  getEvaluationSubmissionData(submissionId: number, activeRole: Roles) {
    return this.abstractEndpoint.getEvaluationSubmissionDataEndpoint<Evaluation>(submissionId, activeRole);
  }

  changeAbstractsStatus(actionAbstracts: ActionAbstracts, odpProjectWorkflowId: number) {
    return this.abstractEndpoint.changeAbstractsStatusEndpoint<boolean>(actionAbstracts, odpProjectWorkflowId);
  }

  getOpenAbstract(activeRole: Roles, activeTeam: number, abstractId: number) {
    return this.abstractEndpoint.getOpenAbstractEndpoint<any>(activeRole, activeTeam, abstractId);
  }

  getUncodedAbstractsCount(activeRole: Roles, activeTeam: number) {
    return this.abstractEndpoint.getUncodedAbstractsCountEndpoint<number>(activeRole, activeTeam);
  }

  getAbstractsByParamsRecon(searchKeys: AbstractSearchKeys) {
    return this.abstractEndpoint.getAbsByParamsReconEndpoint<AbstractSearchResult>(searchKeys);
  }

  autoSampleAbstracts(searchKeys: AbstractSearchKeys) {
    return this.abstractEndpoint.getAutoSampleAbstractsEndpoint<AutoSampleResult>(searchKeys);
  }

  getAbstractsByParamsFullResult(searchKeys: AbstractSearchKeys) {
    return this.abstractEndpoint.getAbsByParamsFullResultEndpoint<AbstractSearchResult>(searchKeys);
  }
}
